import axios from 'axios'

const client = axios.create({
  baseURL: '/api/Config',
  json: true
})

export default {
    async execute (method, resource, data) {
        return client({
            method,
            url: resource,
            data
        }).then(req => {
            return req.data
        })
    },
    get () {
        return this.execute('get', `Get/`)
    }
}
